import { I18n } from '@calendly/i18n';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const stepContainerIsPhoneCss = "swn6m9f";
const stepContainerCss = "s1m90ms8";
const StepContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(stepContainerCss, {
    [stepContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});
const stepContentContainerCss = "s1asbh1s";
const StepContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepContentContainerCss, props.className)} />;
});
const headerCss = "h3xmjnq";
const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h2';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const stepNumberContainerCss = "s11le5z4";
const StepNumberContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepNumberContainerCss, props.className)} />;
});
const stepTitleCss = "san0pga";
const StepTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'h3';
  return <Component ref={ref} {...restProps} className={classNames(stepTitleCss, props.className)} />;
});
const stepDescriptionCss = "s1vy1muy";
const StepDescription = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(stepDescriptionCss, props.className)} />;
});
export const PollContent = () => {
  const pollSteps = [{
    title: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.share_the_link.title'),
    description: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.share_the_link.description')
  }, {
    title: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.track_the_votes.title'),
    description: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.track_the_votes.description')
  }, {
    title: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.book_the_meeting.title'),
    description: I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.book_the_meeting.description')
  }];
  const StepContent = () => pollSteps.map((step, index) => <StepContainer key={step.title}>
        <StepNumberContainer data-testid={`poll-step-${index + 1}`}>
          {index + 1}
        </StepNumberContainer>
        <StepContentContainer>
          <StepTitle>{step.title}</StepTitle>
          <StepDescription>{step.description}</StepDescription>
        </StepContentContainer>
      </StepContainer>);
  return <>
      <Header>{I18n.t('publisher.event_types.one_off_share_modal.poll.next_steps.title')}</Header>
      <StepContent />
    </>;
};

require("./content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./content.js");